import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    BadgeCheck:   <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    BookOpen:     <><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>,
    GraduationCap:<><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:       <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    TrendingUp:   <><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Zap:          <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Home:         <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    ChevronRight: <><path d="m9 18 6-6-6-6"/></>,
    Award:        <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ══ DATA ══ */

const SUB_SERVICES = [
  {
    icon: "BookOpen",
    label: "Primary School Tutoring (Grades 1 to 8)",
    desc: "One-on-one tutoring for pupils in the CBC and 8-4-4 curriculum covering Mathematics, English, Kiswahili, Science, Social Studies, and Creative Arts. Tutors adapt their approach to the child's pace and learning style, building confidence alongside content knowledge.",
    range: "KES 500 – 1,500",
    note: "per hour",
    tags: ["CBC curriculum", "8-4-4", "Maths", "English", "Kiswahili", "Science"],
  },
  {
    icon: "GraduationCap",
    label: "Secondary School Tutoring (Form 1 to 4)",
    desc: "Focused subject tutoring for KCSE candidates and Form 1 to 3 students covering Sciences, Mathematics, English, Kiswahili, Humanities, and Languages. Many tutors on JiraniApp are qualified teachers or recent high-performing graduates with specific subject expertise.",
    range: "KES 800 – 2,500",
    note: "per hour",
    tags: ["KCSE prep", "Sciences", "Maths", "Humanities", "Languages"],
  },
  {
    icon: "TrendingUp",
    label: "University and College Support",
    desc: "Academic support for university and college students covering essay writing, research methods, statistics, accounting, economics, coding, engineering units, and exam revision. Tutors at this level typically hold degrees in the relevant field.",
    range: "KES 1,200 – 4,000",
    note: "per hour",
    tags: ["Essay writing", "Statistics", "Accounting", "Coding", "Engineering"],
  },
  {
    icon: "Award",
    label: "KCPE and KCSE Exam Preparation",
    desc: "Intensive revision sessions designed specifically around the KCPE and KCSE exam formats. Tutors work through past papers, identify weak areas, and build exam technique alongside content revision. Sessions typically start several months before the exam and increase in frequency as the date approaches.",
    range: "KES 1,000 – 3,000",
    note: "per hour",
    tags: ["Past papers", "Exam technique", "Intensive revision", "KCPE", "KCSE"],
  },
  {
    icon: "MessageCircle",
    label: "Language Lessons",
    desc: "Conversational and written lessons in English, Kiswahili, French, German, Mandarin, and Arabic for children and adults. Whether you need to improve your professional English, prepare for a language exam, or learn a new language from scratch, tutors on JiraniApp teach at all levels.",
    range: "KES 700 – 2,500",
    note: "per hour",
    tags: ["English", "French", "Mandarin", "Arabic", "Kiswahili", "German"],
  },
  {
    icon: "Zap",
    label: "Coding and Digital Skills",
    desc: "Tutoring in programming fundamentals, web development, data analysis, Microsoft Office, and digital literacy for students and working adults. Sessions are practical and project-based. Tutors bring laptops and can work with the student on real assignments or personal projects.",
    range: "KES 1,000 – 3,500",
    note: "per hour",
    tags: ["Python", "Web development", "Excel", "Data analysis", "Digital literacy"],
  },
];

const HOW_IT_WORKS = [
  {
    n: "01",
    icon: "Search",
    title: "Search by subject, level, and location",
    desc: "Enter the subject and academic level you need help with, along with your location. JiraniApp surfaces verified tutors in your area who teach that specific subject at that level. You can filter by price, rating, availability, and whether the tutor holds a teaching certificate.",
    detail: "Searches work at the subject level, not just the category. Searching 'Form 3 Biology Nairobi' will show you tutors who have specifically listed Biology for secondary school, not just any science tutor. This matters when you need someone with genuine depth in a particular subject.",
  },
  {
    n: "02",
    icon: "BadgeCheck",
    title: "Review the tutor's profile and qualifications",
    desc: "Every tutor's profile shows their educational background, the subjects and levels they teach, their teaching approach, any certifications or degrees held, and reviews from real clients. You can message them before booking to discuss your child's specific needs, learning pace, or any learning differences you want them to be aware of.",
    detail: "Profiles for tutors include a section for teaching philosophy and approach. A tutor who works well with a struggling learner may use a very different method from one who works best with high-achieving students aiming for top grades. Reading this section carefully before booking saves time and sets the right expectations.",
  },
  {
    n: "03",
    icon: "Calendar",
    title: "Book a session or recurring schedule",
    desc: "Pick a date and time for the first session. You can book a single session to try a tutor before committing, or set up a recurring weekly schedule from the outset. Add any notes about what the student is working on, upcoming exams, or areas the tutor should prioritise in the first session.",
    detail: "Recurring bookings give both the tutor and the student a consistent rhythm. Tutors who see the same student weekly develop a much stronger understanding of their gaps and learning style than those who are booked one-off. If you are approaching an exam, weekly sessions with increased frequency closer to the date is the most common effective approach.",
  },
  {
    n: "04",
    icon: "Home",
    title: "The tutor comes to your home",
    desc: "Your tutor arrives at your home at the agreed time with teaching materials, practice questions, and resources relevant to what you have outlined in the booking. You do not need to prepare anything unless you want the tutor to work through a specific textbook or set of past papers you already have.",
    detail: "Parents of younger students are welcome to be present or nearby during sessions. Most tutors for primary and lower secondary school students expect this and are comfortable with it. For older students, a quiet space away from distractions is the main thing that makes a session productive.",
  },
  {
    n: "05",
    icon: "TrendingUp",
    title: "Track progress and rebook",
    desc: "After each session, you can message the tutor through the app for a brief update on what was covered and what the student should work on before the next session. Most clients track improvement through school test results and tutor feedback over four to six weeks of consistent sessions.",
    detail: "If a tutor is not the right fit after one or two sessions, you can easily book a different one. Reviews and completed job counts on profiles give you a clearer picture over time of who consistently delivers results, and which clients they tend to work best with.",
  },
];

const TRUST_POINTS = [
  {
    icon: "BadgeCheck",
    title: "Identity verified before they go live",
    desc: "Every tutor on JiraniApp goes through identity verification before their profile becomes visible to clients. Tutors with formal teaching qualifications, university degrees, or teaching certificates can upload those credentials and they are displayed on their profile for you to see.",
  },
  {
    icon: "Star",
    title: "Reviews only from real, completed sessions",
    desc: "Every review on a tutor's profile was left by a parent or student who completed and paid for a session through JiraniApp. You cannot leave a review without a verified booking. This means the ratings you see reflect genuine teaching experiences, not self-promotion or unverified feedback.",
  },
  {
    icon: "ShieldCheck",
    title: "Jirani Guarantee on every booking",
    desc: "If your tutor does not show up, cancels last minute without notice, or the session is significantly different from what was agreed and described in the booking, you are covered. Raise a dispute within 48 hours and our team reviews it and works toward a fair resolution, including a refund where warranted.",
  },
  {
    icon: "MessageCircle",
    title: "Direct communication through the platform",
    desc: "All messages between you and a tutor happen inside JiraniApp. This keeps communication on record, protects your privacy, and gives you a clear paper trail if anything needs to be reviewed. You can discuss your child's needs, share past papers, and get session updates all in one place without exchanging personal numbers.",
  },
];

const TESTIMONIALS = [
  {
    name: "Caroline N.",
    area: "Karen, Nairobi",
    service: "KCSE Maths tutor for daughter",
    rating: 5,
    text: "My daughter was failing Mathematics in Form 3 and I did not know where to find consistent, reliable help. I found a tutor on JiraniApp who had a degree in Engineering and strong reviews from other KCSE parents. She started in August and by October her mock results had improved by two grade levels. The tutor keeps me updated after every session and the booking process is completely straightforward. I cannot recommend this highly enough.",
  },
  {
    name: "Brian O.",
    area: "Kilimani, Nairobi",
    service: "Python coding lessons for himself",
    rating: 5,
    text: "I needed to learn Python for a new role at work and I did not want to do another online course on my own. I booked a tutor through JiraniApp who has a Computer Science background and teaches programming to adults. He came to my apartment twice a week for six weeks, worked through real problems with me, and by the end of the engagement I was writing clean scripts for data cleaning tasks at work. Worth every shilling.",
  },
  {
    name: "Asha M.",
    area: "Nyali, Mombasa",
    service: "CBC Grade 5 tutor for son",
    rating: 5,
    text: "Finding a tutor who genuinely understands the CBC curriculum in Mombasa was harder than I expected. Through JiraniApp I found a tutor who had been trained specifically in CBC and had taught in a school using it. She has been coming to our home every Saturday and Wednesday for three months now and the change in my son's attitude toward school has been remarkable. He actually looks forward to the sessions.",
  },
];

const FAQS = [
  {
    q: "How do I know a tutor is actually qualified to teach the subject I need?",
    a: "Tutors on JiraniApp can upload their academic certificates, teaching diplomas, and degrees to their profile, and these are displayed publicly. You can see their educational background and the specific subjects and levels they have listed themselves as teaching. Before booking, you can also message them directly to ask about their experience with a particular curriculum, syllabus, or student profile. Reviews from previous clients often mention the tutor's depth of knowledge and teaching effectiveness, which gives you a practical sense of results beyond qualifications on paper.",
  },
  {
    q: "Can I book a tutor for my child who has a learning difference or special need?",
    a: "Yes, and this is worth discussing with a tutor before you book. Some tutors on JiraniApp have experience working with students who have dyslexia, dyscalculia, ADHD, or other learning differences, and this is often mentioned in their profile or in their client reviews. When messaging a tutor before booking, describe your child's specific situation and ask whether they have relevant experience. Booking an initial trial session first, rather than committing to a recurring schedule immediately, is the most sensible approach when matching with a tutor for a child with specific learning needs.",
  },
  {
    q: "What is the difference between a one-off session and a recurring booking?",
    a: "A one-off session is a single booked appointment with no commitment beyond that session. Many clients use one-off sessions to try a tutor before deciding whether they are the right fit for their child. A recurring booking sets up a regular weekly or biweekly schedule with the same tutor. Recurring bookings tend to be more effective because the tutor develops a deeper understanding of the student over time and can track progress session by session. You can switch between arrangements at any time from your Bookings dashboard.",
  },
  {
    q: "What should the student prepare before the first session?",
    a: "In most cases, nothing specific is required. When you book, you can add notes about what the student is currently working on, any upcoming tests or exams, and topics they are struggling with. The tutor reads these notes and comes prepared with relevant materials. If you want the tutor to work through a specific textbook, past paper set, or school assignment, mention this in the booking notes and have those materials ready. For older students, having a list of current topics from their school syllabus is helpful but not essential.",
  },
  {
    q: "How long should each tutoring session be?",
    a: "For primary school children in Grades 1 to 4, 45 to 60 minutes is typically the most productive session length. Children in upper primary and lower secondary can generally sustain 60 to 90 minutes effectively. For Form 3 and 4 KCSE students and university students, sessions of 90 minutes to two hours are common, particularly during intensive exam revision periods. You and the tutor will arrive at a rhythm that works for the student after the first one or two sessions. You can specify your preferred duration when booking.",
  },
  {
    q: "Can a tutor teach multiple subjects in one session?",
    a: "Yes, provided the tutor you book teaches all the subjects you need. Some tutors specialise in a single subject while others are generalist primary school tutors comfortable across the full primary curriculum. Check a tutor's profile to see which subjects they have listed before booking. If you need help across multiple subjects and cannot find one tutor who covers all of them, it is common to book different tutors for different subjects and manage them through your JiraniApp dashboard.",
  },
  {
    q: "What if my child and the tutor are not a good match?",
    a: "This happens and it is completely normal. Not every teaching style suits every learner. If after one or two sessions you feel the tutor is not the right fit, you can simply book a different tutor without any obligation. The first session is effectively a trial. Reviews from other parents will often give you signals about the tutor's style before you commit, particularly comments about patience, flexibility, and how well they handle students who are behind or struggling with confidence.",
  },
  {
    q: "Is tutoring available for adult learners, not just school-age students?",
    a: "Yes. Several tutors on JiraniApp work specifically with adult learners for professional development, language learning, digital skills, and university-level coursework. Adult tutoring tends to be more goal-specific than school tutoring, whether that is preparing for a professional exam, improving written English for work, or learning a programming language. When searching, filter by academic level or use the subject search to find tutors who list adult learners as part of their client base.",
  },
];

/* ── Reusable sub-components ── */

function StarRating({ count = 5 }) {
  return (
    <div style={{ display: "flex", gap: 2 }}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill={T.amber} stroke={T.amber} strokeWidth="1">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ))}
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 500 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.8, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function ServiceCard({ icon, label, desc, range, note, tags }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", display: "flex", flexDirection: "column", gap: 12,
      }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 11, flexShrink: 0,
          background: hovered ? T.g100 : T.n50,
          border: `1px solid ${hovered ? T.g200 : T.n150}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .18s",
        }}>
          <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>{range}</div>
          <div style={{ fontSize: 11, color: T.n400, marginTop: 2 }}>{note}</div>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{label}</div>
        <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
        {tags.map((tag, i) => (
          <span key={i} style={{
            fontSize: 11, color: hovered ? T.g700 : T.n600,
            background: hovered ? T.g100 : T.n50,
            border: `1px solid ${hovered ? T.g200 : T.n150}`,
            borderRadius: 99, padding: "3px 10px", fontWeight: 500,
            transition: "all .18s",
          }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

function StepCard({ step, isLast }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ display: "flex", gap: 20, position: "relative" }}>
      {!isLast && (
        <div style={{
          position: "absolute", left: 23, top: 52, bottom: open ? -8 : -20,
          width: 1, background: `linear-gradient(to bottom, ${T.g200}, ${T.n100})`,
          transition: "bottom .3s",
        }} />
      )}
      <div style={{
        width: 48, height: 48, borderRadius: 14, flexShrink: 0, zIndex: 1,
        background: T.g50, border: `1.5px solid ${T.g100}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={step.icon} size={20} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingBottom: isLast ? 0 : 44 }}>
        <button onClick={() => setOpen(o => !o)} style={{
          width: "100%", background: "none", border: "none", cursor: "pointer",
          padding: 0, textAlign: "left", fontFamily: T.sans,
          display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12,
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", marginBottom: 5 }}>STEP {step.n}</div>
            <div style={{ fontFamily: T.serif, fontSize: "clamp(17px,2.5vw,21px)", fontWeight: 400, color: T.n900, letterSpacing: "-0.02em", lineHeight: 1.25 }}>{step.title}</div>
          </div>
          <span style={{
            width: 26, height: 26, borderRadius: "50%", flexShrink: 0, marginTop: 16,
            border: `1px solid ${open ? T.g500 : T.n200}`,
            background: open ? T.g500 : "transparent",
            color: open ? T.white : T.n400,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 16, fontWeight: 300, lineHeight: 1,
            transition: "all .2s", transform: open ? "rotate(45deg)" : "none",
          }}>+</span>
        </button>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.8, margin: "10px 0 0" }}>{step.desc}</p>
        <div style={{ overflow: "hidden", maxHeight: open ? 200 : 0, transition: "max-height .3s cubic-bezier(.4,0,.2,1)" }}>
          <div style={{ marginTop: 14, padding: "14px 16px", background: T.g50, borderRadius: 10, border: `1px solid ${T.g100}` }}>
            <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{step.detail}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Testimonial({ name, area, service, rating, text }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const palette = [
    { bg: T.g50,     text: T.g700,    border: T.g100 },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
    { bg: "#fdf4ff", text: "#7e22ce", border: "#e9d5ff" },
  ];
  const c = palette[name.charCodeAt(0) % palette.length];
  return (
    <div style={{ padding: "24px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 16 }}>
      <StarRating count={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.85, margin: 0, fontStyle: "italic" }}>"{text}"</p>
      <div style={{ borderTop: `1px solid ${T.n100}`, paddingTop: 16, display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: c.bg, border: `1.5px solid ${c.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 600, color: c.text, flexShrink: 0 }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{service} · {area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function HomeTutoringPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [locationFocused, setLocationFocused] = useState(false);

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "home-tutoring" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 80 }}>
      <style>{`* { box-sizing: border-box; } ::-webkit-scrollbar { display: none; }`}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6, background: "none",
          border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/become-a-pro")} style={{
          display: "inline-flex", alignItems: "center", gap: 6, background: "none",
          border: `1px solid ${T.n200}`, cursor: "pointer", color: T.n600,
          fontSize: 13, fontFamily: T.sans, padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.g400; e.currentTarget.style.color = T.g600; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          <Icon name="GraduationCap" size={13} strokeWidth={2} />
          Are you a tutor? Join free
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(44px,5vw,64px)", borderBottom: `1px solid ${T.n100}`, background: `linear-gradient(160deg, ${T.g50} 0%, ${T.white} 60%)` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="BookOpen" size={14} color={T.g500} strokeWidth={2.2} />
            Home Tutoring
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,68px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.06, color: T.n900, letterSpacing: "-0.03em", maxWidth: 640 }}>
            Verified tutors who come<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>to your home</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 36px", maxWidth: 520 }}>
            Find qualified tutors for primary, secondary, university, and adult learners across every subject. One-off sessions or recurring schedules, all booked and paid through JiraniApp.
          </p>

          {/* Search bar */}
          <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
            <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
              <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              </span>
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setLocationFocused(true)}
                onBlur={() => setLocationFocused(false)}
                onKeyDown={e => e.key === "Enter" && handleSearch()}
                placeholder="Your estate or area..."
                style={{
                  width: "100%", padding: "15px 16px 15px 42px",
                  border: `1px solid ${locationFocused ? T.g500 : T.n200}`,
                  borderRadius: 11, fontSize: 14, outline: "none",
                  background: T.white, color: T.n900, fontFamily: T.sans,
                  boxShadow: locationFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.06)",
                  transition: "all .18s",
                }} />
            </div>
            <button onClick={handleSearch} style={{
              padding: "15px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
              display: "inline-flex", alignItems: "center", gap: 8, whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find a tutor
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n400, margin: "12px 0 0" }}>
            Available in Nairobi, Mombasa, Kisumu, Nakuru and Eldoret
          </p>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck",  label: "ID-verified tutors with qualifications displayed" },
            { icon: "Star",        label: "Reviews only from verified, completed sessions" },
            { icon: "ShieldCheck", label: "Jirani Guarantee covers every booking" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.5} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>What tutors offer</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Every level, every subject,<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>at your home</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            JiraniApp tutors cover the full range from CBC primary school through to university and adult professional development. Each tutor lists their exact subjects, levels, and hourly rate so you know exactly what you are getting before you book.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map((s, i) => <ServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            From search to first session in <em style={{ fontStyle: "italic", color: T.g600 }}>five steps</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 32px", lineHeight: 1.65 }}>
            Tap any step to see what actually happens at that stage.
          </p>
          <div style={{ paddingLeft: 4 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <StepCard key={i} step={step} isLast={i === HOW_IT_WORKS.length - 1} />
            ))}
          </div>
        </div>

        {/* ══ TRUST SECTION ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,44px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Your protection</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,34px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Letting someone teach your child<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>requires trust</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 28px" }}>
            Here is exactly how JiraniApp earns and maintains that trust on every tutoring booking.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20 }}>
            {TRUST_POINTS.map((pt, i) => (
              <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={pt.icon} size={16} color={T.g500} strokeWidth={1.7} />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6, letterSpacing: "-0.01em" }}>{pt.title}</div>
                  <p style={{ fontSize: 13, color: T.g700, lineHeight: 1.75, margin: 0 }}>{pt.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Client stories</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What parents and students say after <em style={{ fontStyle: "italic", color: T.g600 }}>real sessions</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            Every review below is from a verified booking on JiraniApp. No editorial. No incentivised reviews.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <Testimonial key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book a tutor</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything parents, students, and adult learners ask us most often.
          </p>
          <div style={{ marginTop: 8 }}>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50, marginBottom: 20 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="BookOpen" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,38px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Find the right tutor<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>for your learner</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 420 }}>
            Browse verified tutors near you, check their qualifications and reviews, and book a session that fits your schedule. They come to you.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={handleSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a tutor near me
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              How JiraniApp works
            </button>
          </div>
          <p style={{ fontSize: 12, color: T.n300, margin: "20px 0 0" }}>
            Free to browse · No booking fees · Pay only when you confirm
          </p>
        </div>

      </div>
    </div>
  );
}